/**
 * 模型状态管理器
 * 提供全局模型状态管理，遵循单例模式
 */
export class ModelStateManager {
    constructor() {
        this.listeners = new Set();
        this.currentModelId = this.getDefaultModel();
    }
    static getInstance() {
        if (!ModelStateManager.instance) {
            ModelStateManager.instance = new ModelStateManager();
        }
        return ModelStateManager.instance;
    }
    /**
     * 获取当前模型
     */
    getModel() {
        return this.currentModelId;
    }
    /**
     * 设置模型并通知监听器
     */
    setModel(modelId) {
        if (this.currentModelId !== modelId) {
            this.currentModelId = modelId;
            this.notifyListeners(modelId);
        }
    }
    /**
     * 获取默认模型ID
     */
    getDefaultModel() {
        return 'deepseek-v3';
    }
    /**
     * 添加模型变化监听器
     * @returns 取消订阅函数
     */
    subscribe(listener) {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }
    /**
     * 通知所有监听器
     */
    notifyListeners(modelId) {
        this.listeners.forEach(listener => listener(modelId));
    }
}
export default ModelStateManager;
//# sourceMappingURL=ModelStateManager.js.map